import Tier0WaitingPage from '@/components/Tier0WaitingPage/Tier0WaitingPage'
import { useUser } from '@/contexts/user/User.context'

import type { ReactNode } from 'react'

type SellerTierProviderProps = {
  children: ReactNode
}

export const SellerTierProvider = ({ children }: SellerTierProviderProps) => {
  const { user, isLoading } = useUser()
  const { sellerConfig } = user || {}
  const { sellerTier } = sellerConfig || {}
  const { name } = sellerTier || {}

  if (!isLoading && name && name === 'tier0') return <Tier0WaitingPage />

  return <>{children}</>
}
